export function reportMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      reportId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateReportId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}

export function fixCreateReportId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function fixGetManyReport(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      reportId: resource.objectId,
    })),
  };
}

export function reportMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, reportId: json.result.objectId},
  };
}